exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cuadraturaOS .estilo-grilla {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.cuadraturaOS .ag-root-wrapper-body .ag-pinned-left-header,\n.cuadraturaOS .ag-root-wrapper-body .ag-pinned-left-cols-container,\n.cuadraturaOS .ag-root-wrapper-body .ag-horizontal-left-spacer {\n  display: none;\n}\n", ""]);

// exports
